import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Switch from "../../../components/Switch/Switch.jsx";
import { CleaveInput } from "../../../components/CleaveInput/CleaveInput.js";
import LoadingIndicator from "../../../utils/LoadingIndicator/LoadingIndicator";
import {
  headingItemsManageOrder,
  controlItems,
} from "../../../utils/Data/dataTexts";
import axios from "../../../utils/Axios/axiosProxy";
import { MultilineInput } from "../../../components/FormInputs/FormInputs";
import { AdminDashboardContext } from "../AdminDashboard";
import Quotation from "./Quotation";
import UploadDocument from "../../../components/UploadDocument/UploadDocument.jsx";
/* import ImportCustoms from "./PDFs/ImportCustoms.jsx";
import CustomsDirectRep from "./PDFs/CustomsDirectRep.jsx";
import ExportCustoms from "./PDFs/ExportCustoms.jsx"; */

function ManageOrder({ ...props }) {
  const [order, setOrder] = React.useState("");
  const [saved, setSaved] = React.useState(false);
  const [locationChange, setLocationChange] = React.useState(false);
  const [paymentChange, setPaymentChange] = React.useState(false);
  const [messageChange, setMessageChange] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  const adminDashboardContext = React.useContext(AdminDashboardContext);

  useEffect(() => {
    setOrder(props.order);
    setLoading(false);
  }, [props.order, loading]);
  const updateOrder = () => {
    let data = {
      orderID: order._id,
      updateParams: {
        etr: order.etr,
        atr: order.atr,
        status: order.status,
        notes: order.notes,
        active: order.active,
        payment: order.payment,
        paymentdue: order.paymentdue,
        complete: order.complete !== undefined ? order.complete : false,
      },
      location: locationChange,
      payment: paymentChange,
      message: messageChange,
    };
    axios
      .patch("/api/order/update", data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        adminDashboardContext.getOrdersFromDB(localStorage.getItem("JWT"));
        setLocationChange(false);
        setPaymentChange(false);
        setMessageChange(false);
        console.log("UPDATE ORDER RESPONSE: ", response.statusText);
      })
      .catch((error) => {
        console.log("UPDATE ORDER ERROR: ", error.response.data);
      })
      .catch((error) => console.log("submitToDB error", error));
  };
  const handleCheck = (event) => {
    if (saved) {
      setSaved(false);
    }
    setOrder({ ...order, [event.target.id]: event.target.checked });
  };
  const handleChange = (event) => {
    if (saved) {
      setSaved(false);
    }
    if (event.target.id === "status") {
      setLocationChange(true);
    }
    if (event.target.id === "notes") {
      setMessageChange(true);
    }
    setOrder({ ...order, [event.target.id]: event.target.value });
  };
  const handleTime = (event, obj) => {
    if (saved) {
      setSaved(false);
    }
    setOrder({
      ...order,
      [obj]: { ...order[obj], [event.target.id]: event.target.value },
    });
    setLocationChange(true);
  };
  const handleDropdown = (event) => {
    if (saved) {
      setSaved(false);
    }
    if (event.target.name === "payment") {
      setPaymentChange(true);
    }
    setOrder({ ...order, [event.target.name]: event.target.value });
  };
  const setHeadingItem = (item) => {
    switch (item.id) {
      case "active":
        return (
          <>
            <Switch
              name={item.label}
              id={item.id}
              word1="Yes"
              word2="No"
              checked={order.active}
              onChange={(event) => handleCheck(event)}
            />
          </>
        );
      case "payment":
        return (
          <>
            <FormControl
              variant="outlined"
              style={{ minWidth: "140px", paddingTop: "16px" }}
              className="MarginSides"
            >
              <Select
                name="payment"
                displayEmpty
                value={order.payment}
                onChange={(event) => handleDropdown(event)}
              >
                <MenuItem value="">Processing</MenuItem>
                <MenuItem value="open">Open</MenuItem>
                <MenuItem value="paid">Paid</MenuItem>
                <MenuItem value="overdue">Overdue</MenuItem>
              </Select>
            </FormControl>
          </>
        );
      case "complete":
        return (
          <>
            <Switch
              name={item.label}
              id={item.id}
              word1="Yes"
              word2="No"
              checked={order.complete}
              onChange={(event) => handleCheck(event)}
            />
          </>
        );
      default:
        return order[item.id];
    }
  };
  return (
    <>
      <div className="ManageOrderContainer MarginHorizontal">
        {loading ? (
          <LoadingIndicator />
        ) : (
          <>
            {window.innerWidth >= 600 ? (
              <div className="OrderHeading">
                {headingItemsManageOrder.map((item) => {
                  return (
                    <div className="HeadingItems" key={item.label}>
                      <li className="WhiteItalic">{item.label}</li>

                      <li className="Bold" id={item.id}>
                        {setHeadingItem(item)}
                      </li>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="Column">
                {headingItemsManageOrder.map((item) => {
                  return (
                    <div className="HeadingItems" key={item.label}>
                      <p className="OrangeFont Bold ">{item.label}</p>

                      <span className="Bold" id={item.id}>
                        {setHeadingItem(item)}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}

            <div>
              <FormControl component="fieldset" style={{ width: "100%" }}>
                <RadioGroup
                  name="status"
                  value={order.status}
                  id="status"
                  onChange={(event) => handleChange(event)}
                >
                  {controlItems.map((item) => {
                    return (
                      <div
                        className={
                          window.innerWidth >= 600
                            ? "Row Padding8 Border"
                            : "Column Padding8 Border"
                        }
                      >
                        <div className="RadioContainerAdmin">
                          <FormControlLabel
                            style={{
                              fontSize: "10px",
                            }}
                            value={item.value}
                            control={<Radio color="primary" id="status" />}
                            label={
                              <span className="RadioLabel">{item.label}</span>
                            }
                          />
                        </div>
                        <div className="Row MarginSides FlexCenter">
                          <p className="Width100">Estimated</p>
                          <TextField
                            style={{ width: "200px" }}
                            className="MarginSides"
                            id={item.value}
                            placeholder="YYYY-MM-DD HH:MM"
                            variant="outlined"
                            value={order.etr[item.value]}
                            onChange={(event) => handleTime(event, "etr")}
                            type="dateandtime"
                            InputProps={{ inputComponent: CleaveInput }}
                          />
                        </div>
                        <div className="MarginSides Row FlexCenter">
                          <p className="Width100">Actual</p>
                          <TextField
                            style={{ width: "200px" }}
                            className="MarginSides"
                            id={item.value}
                            placeholder="YYYY-MM-DD HH:MM"
                            variant="outlined"
                            value={
                              order.atr !== undefined
                                ? order.atr[item.value]
                                : ""
                            }
                            onChange={(event) => handleTime(event, "atr")}
                            type="dateandtime"
                            InputProps={{ inputComponent: CleaveInput }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </RadioGroup>
              </FormControl>
              <div className="OrderNotes BottomBorder">
                <p className="OrangeFont Bold">Documents</p>
                <UploadDocument
                  userID={order.userID}
                  orderID={order._id}
                  orderDocuments={order.documents}
                  contactEmail={order.contact.email}
                  contactName={order.contact.firstname}
                />
              </div>
              <div className="OrderNotes BottomBorder">
                <p className="OrangeFont Bold">Payment Due</p>
                <TextField
                  style={{ width: "200px" }}
                  className="MarginSides"
                  id="paymentdue"
                  placeholder="yyyy-MM-dd"
                  variant="outlined"
                  value={order.paymentdue}
                  onChange={(event) => {
                    if (saved) {
                      setSaved(false);
                    }
                    setOrder({
                      ...order,
                      paymentdue: event.target.value,
                    });
                    setPaymentChange(true);
                  }}
                  type={"date"}
                  InputProps={{ inputComponent: CleaveInput }}
                />
              </div>
              <div className="OrderNotes">
                <p className="OrangeFont Bold">Notes</p>
                <MultilineInput
                  value={order.notes}
                  onChange={(event) => handleChange(event)}
                  id="notes"
                />
              </div>
            </div>
            <div
              className="Padding MarginRight"
              style={{ alignSelf: "flex-end" }}
            >
              {saved ? (
                <div>
                  <Button
                    onClick={() => {
                      updateOrder();
                      setSaved(true);
                    }}
                    className="ToreaBay Small MarginSides"
                  >
                    Send
                  </Button>
                  <p style={{ color: "#1cb71c" }}>Succesfully sent</p>
                </div>
              ) : (
                <Button
                  onClick={() => {
                    updateOrder();
                    setSaved(true);
                  }}
                  className="ToreaBay Small"
                >
                  Send
                </Button>
              )}
            </div>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                className="BoxShadow"
              >
                <h2>Quotation</h2>
              </AccordionSummary>
              <Quotation order={order} />
            </Accordion>
            {/*            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                className="BoxShadow"
              >
                <h2>Import Customs Clearance</h2>
              </AccordionSummary>
              <ImportCustoms order={order} />
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                className="BoxShadow"
              >
                <h2>Customs Direct Representation</h2>
              </AccordionSummary>
              <CustomsDirectRep order={order} />
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                className="BoxShadow"
              >
                <h2>Export Customs Clearance</h2>
              </AccordionSummary>
              <ExportCustoms order={order} />
            </Accordion> */}
          </>
        )}
      </div>
    </>
  );
}

export default ManageOrder;
